export default "__VITE_ASSET__CnOmwwnR__"